// extracted by mini-css-extract-plugin
export var danger = "_2y-6";
export var lightPink = "_2y-a";
export var medium = "_2y-j";
export var nearSquare = "_2y-m";
export var neutralBlue = "_2y-8";
export var neutralYellow = "_2y-7";
export var noCapitalize = "_2y-1";
export var normal = "_2y-2";
export var pill = "_2y-0";
export var primary = "_2y-3";
export var primaryLight = "_2y-4";
export var shadow = "_2y-n";
export var small = "_2y-k";
export var solidBlack = "_2y-i";
export var solidGreen = "_2y-d";
export var solidLightBlue = "_2y-f";
export var solidNavy = "_2y-e";
export var solidOrange = "_2y-h";
export var solidPink = "_2y-g";
export var solidRed = "_2y-b";
export var solidWhite = "_2y-9";
export var solidYellow = "_2y-c";
export var success = "_2y-5";
export var xsmall = "_2y-l";